import { createAction } from 'redux-actions';

export const APP_SET_COMPUTING = 'APP_SET_COMPUTING';

export const appSetComputing = createAction(APP_SET_COMPUTING);
